export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/forte-icon.svg?ef1c62d5b5ee456feeda9c3a899fd091";